import httpClient from './httpClient';
import envVar from '../config/envVars';
import {
  PhotoIdCardsApiResponse,
  GeneratePdfResponse
} from '../modules/IdCards/types/IdCardTypes';
import { GeneratePdfArgs, GetPhotoIdCardsArgs } from '../types/idCardsType';

const getPhotoIdCards = async (
  args: GetPhotoIdCardsArgs
): Promise<PhotoIdCardsApiResponse> => {
  const { school, academicYear, ...body } = args;
  const url = `${envVar.REACT_APP_BASE_API_URL}/schools/${school}/users/${academicYear}/photo-id-cards`;
  const response: any = await httpClient.post(url, body, {});
  return response as PhotoIdCardsApiResponse;
};

const generatePhotoIdCardsPdf = async (
  args: GeneratePdfArgs
): Promise<GeneratePdfResponse> => {
  const { school, academicYear, ...body } = args;
  const url = `${envVar.REACT_APP_BASE_API_URL}/schools/${school}/users/${academicYear}/photo-id-cards/generate`;
  const response: any = await httpClient.post(url, body, {});
  return response as GeneratePdfResponse;
};

const idCardsApis = { getPhotoIdCards, generatePhotoIdCardsPdf };

export default idCardsApis;
